export * from './IconDrillingPartLeftStroked';
